import PlayerUserLimitsCard from './PlayerUserLimitsCard.svelte';


!customElements.get('player-user-limits-card') && customElements.define('player-user-limits-card', PlayerUserLimitsCard);
export default PlayerUserLimitsCard;
